import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

const DocumentButtons = ({
  user,
  permList,
  requestRehireDoc,
  docRequest,
  requestRehireDocStatus,
  onDocumentRequest,
  onDownloadAllDocuments,
  onDownloadAllDocumentsAsPDF,
  onDocRequestModalClose,
}) => {
  return (
    <React.Fragment>
      {permList.includes('Manage Docs') && user && user.docs_status === -1 && (
        <button
          className={`button edit_resource ${
            user?.rehire_docs_status !== -1 && 'disabled'
          }`}
          onClick={() => onDocumentRequest(user.hash, 'onboarding')}
          disabled={user?.docs_status !== -1}
        >
          {user?.docs_status === -1
            ? 'Ask to Fill Onboarding Documents'
            : 'Asked to Fill Onboarding Documents'}
        </button>
      )}

      {permList.includes('Manage Docs') &&
        user && user.rehire_docs_status === -1 &&
        user.docs_status >= 2 && (
          <button
            className={`button edit_resource ${
              (user?.rehire_docs_status !== -1 || user?.committed_to_manifest) &&
              'disabled'
            }`}
            onClick={() => onDocumentRequest(user.hash, 'rehire')}
            disabled={user?.rehire_docs_status !== -1 || Boolean(user?.committed_to_manifest)}
          >
            {user?.rehire_docs_status === -1
              ? 'Ask to Fill Rehire Documents'
              : 'Asked to Fill Rehire Documents'}
          </button>
        )}

      {/* Onboarding */}
      {permList.includes('Manage Docs') && user && user.docs_status >= 2 && (
        <button
          className='button edit_resource'
          onClick={onDownloadAllDocuments}
          title='Download Onboarding documents as ZIP File'
        >
          Onboarding{' '}
          <i className='fas fa-file-archive text-white inline-icons'></i>
        </button>
      )}

      {permList.includes('Manage Docs') && user && user.docs_status >= 2 && (
        <button
          className='button primary edit_resource'
          onClick={onDownloadAllDocumentsAsPDF}
          title='Download Onboarding documents as PDF'
        >
          Onboarding <i className='fas fa-file-pdf text-white inline-icons'></i>
        </button>
      )}

      {/* Rehire */}
      {permList.includes('Manage Docs') && user && user.rehire_docs_status >= 2 && (
        <button
          className='button edit_resource'
          onClick={(event) => onDownloadAllDocuments(event, true, false)}
          title='Download Rehire documents as ZIP File'
        >
          Rehire <i className='fas fa-file-archive text-white inline-icons'></i>
        </button>
      )}

      {permList.includes('Manage Docs') && user && user.rehire_docs_status >= 2 && (
        <button
          className='button primary edit_resource'
          onClick={(event) => onDownloadAllDocumentsAsPDF(event, true, false)}
          title='Download Rehire documents as PDF'
        >
          Rehire <i className='fas fa-file-pdf text-white inline-icons'></i>
        </button>
      )}

      {/* Ask Rehire Modal */}
      <ReactModal
        isOpen={requestRehireDoc}
        onClose={onDocRequestModalClose}
        contentLabel='Rehire Request'
        overlayClassName='alertPopup'
      >
        <div id='rehire_request' className='popupModal'>
          <div className='modal-head'>
            <h4 className='modal-title'>Request {docRequest || 'Documents'} Docs</h4>
          </div>
          <div className='modal-body'>
            {requestRehireDocStatus ? (
              <p>
                Request for fill out{' '}
                <span className='modal-word-highlight'>
                  {docRequest?.toUpperCase() || 'DOCUMENTS'} documents
                </span>
                ,sent out to the user.
              </p>
            ) : (
              <p>
                Unable to request{' '}
                <strong>{docRequest?.toUpperCase() || 'DOCUMENTS'} documents</strong>
                !!!
              </p>
            )}
            <div className='btn_list'>
              <button className='button' onClick={onDocRequestModalClose}>
                Ok
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </React.Fragment>
  );
};

DocumentButtons.propTypes = {
  user: PropTypes.object,
  permList: PropTypes.array,
  requestRehireDoc: PropTypes.bool,
  docRequest: PropTypes.string,
  requestRehireDocStatus: PropTypes.bool,
  onDocumentRequest: PropTypes.func.isRequired,
  onDownloadAllDocuments: PropTypes.func.isRequired,
  onDownloadAllDocumentsAsPDF: PropTypes.func.isRequired,
  onDocRequestModalClose: PropTypes.func.isRequired,
};

export default DocumentButtons;
